export const cameraTypesMap = {
	air: 'Pixellot Air',
	action: 'SJ Camera'
}
